module.exports = __webpack_public_path__ + "img/password.1ad7a3ee.svg";